// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface CopyrightIconSignature {
  Element: SVGSVGElement;
}

export const CopyrightIcon: TOC<CopyrightIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M4 4H20C21.103 4 22 4.896 22 6V18C22 19.103 21.103 20 20 20H4C2.897 20 2 19.103 2 18V6C2 4.896 2.897 4 4 4ZM4 6V18H20.001L20 6H4ZM6 11V13C6 14.654 7.346 16 9 16H11V14H9C8.449 14 8 13.552 8 13V11C8 10.449 8.449 10 9 10H11V8H9C7.346 8 6 9.346 6 11ZM13 13V11C13 9.346 14.346 8 16 8H18V10H16C15.449 10 15 10.449 15 11V13C15 13.552 15.449 14 16 14H18V16H16C14.346 16 13 14.654 13 13Z"/>
</svg>
</template>;